import { ROLE_PERMISSIONS } from "../apiEndpoint";
import { educationAxios } from "../http/http";

export default function rolesPermissionsUpdate(useremail,payload) {
  return educationAxios.put(
    `${ROLE_PERMISSIONS}?user_email=${useremail}`, payload)
}
